/**
 * Libellé de plage pour la liste Clients Super Admin (pagination serveur).
 * @param {number} listPage - page 1-based
 * @param {number} pageSize
 * @param {number} listTotal - total API pagination.total
 * @returns {string}
 */
export function formatClientsPageRange(listPage, pageSize, listTotal) {
  const total = Number(listTotal) || 0;
  if (total === 0) return '0 client';

  const page = Math.max(1, Number(listPage) || 1);
  const size = Math.max(1, Number(pageSize) || 1);
  const from = (page - 1) * size + 1;
  const to = Math.min(page * size, total);

  if (from === to) {
    return `${from} sur ${total} client${total > 1 ? 's' : ''}`;
  }
  return `${from}–${to} sur ${total} clients`;
}
